export const LINKS = {
    GET_A_WALLET: 'https://get.gramwallet.io/?utm_source=tonconnect&utm_medium=help'
};
